import React from "react";
import Toolbar from "../../../components/SegmentBuilder/Toolbar";
import { Container } from "../../../components/SegmentBuilder/Toolbar/styles";
import DefaultSidePane from "../../../components/SegmentBuilder/Shared/DefaultSidePane";
import { ASSETS } from "../../../utils/config";
import { useSelector } from "react-redux";
import { getSelectedSegment } from "../../../redux/selectors/segmentBuilderSelectors";
const Right = ({ segmentSettings, handleChange, isVisible = false }) => {
  const selectedArc = useSelector(getSelectedSegment);

  return (
    <div>
      <Container>
        <DefaultSidePane
          title={"Build"}
          titleImage={ASSETS.segmentEditor.Edit}
          text={" Open a segment to start adding content blocks!"}
          selectedArc={selectedArc}
        />
        <Toolbar
          onClose={() => {}}
          segmentSettings={segmentSettings}
          handleChange={handleChange}
          isVisible={isVisible}
        />
      </Container>
    </div>
  );
};

export default Right;
